import getServerErrorMessage from 'app/utilities/getServerErrorMessage';
import { SagaIterator } from 'redux-saga';
import {
  all,
  call,
  cancel,
  cancelled,
  fork,
  put,
  take,
} from 'redux-saga/effects';

import { verifyAccountAPIRequest } from '../api';
import {
  cancelAuthTask,
  clearError,
  clearSucces,
  endAuthTask,
  onError,
  onSuccess,
  startAuthTask,
  verifyAccountRequest,
} from './auth-slice';

export function* validateToken(payload: string): SagaIterator {
  try {
    yield put(startAuthTask());
    yield call(verifyAccountAPIRequest, payload);
    yield all([
      put(onSuccess('Account created successfuly.')),
      put(clearError()),
    ]);
  } catch (error) {
    const errorMsg = getServerErrorMessage(error);
    yield all([put(onError(errorMsg)), put(clearSucces())]);
  } finally {
    if (yield cancelled()) {
      yield all([put(clearError()), put(clearSucces())]);
    }

    yield put(endAuthTask());
  }
}

export function* verifyAccountFlow(): SagaIterator {
  while (true) {
    const { payload } = yield take(verifyAccountRequest);
    const validateTokenTask = yield fork(validateToken, payload);
    const nextAction = yield take([cancelAuthTask, endAuthTask]);
    if (nextAction.type === cancelAuthTask.type) {
      yield cancel(validateTokenTask);
    }
  }
}
